import React from "react";

import { ValueGridBlock as Value, ValueGridItemBlock } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { RichTextBlock } from "../RichText";
import { Svg } from "../Svg";

import styles from "./ValueGridBlock.module.scss";

function ValueItem({ value }: { value: ValueGridItemBlock }) {
    return (
        <div className={styles.card}>
            {value.icon && (
                <div className={styles.cardIcon}>
                    <Svg name={value.icon} />
                </div>
            )}
            <h3 className={styles.cardHeading}>{value.heading}</h3>
            <p className={styles.cardBody}>{value.body}</p>
        </div>
    );
}

export function ValueGridBlock(props: Value) {
    return (
        <section className={styles.root}>
            <div className={styles.layout}>
                <div className={styles.graphicColumn}></div>
                <div className={styles.contentColumn}>
                    {props.heading && (
                        <RichTextBlock
                            value={props.heading}
                            largeHeadings={true}
                            className={styles.heading}
                        />
                    )}
                    {props.sub_copy && (
                        <RichTextBlock
                            value={props.sub_copy}
                            className={styles.subCopy}
                        />
                    )}
                    {props.items && (
                        <StreamField
                            attrs={{ className: styles.grid }}
                            value={props.items}
                            components={{
                                item: ({ value }) => (
                                    <ValueItem value={value} />
                                ),
                            }}
                        />
                    )}
                </div>
            </div>
        </section>
    );
}
